import BidModal from '@components/BidModal/BidModal'
import BanModal from '@components/BanModal/BanModal'
import OfferModal from '@components/OfferModal/OfferModal'
import ViewModal from '@components/ViewModal/ViewModal'
import React, { useContext } from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import BidIncrementModal from '@components/Cards/BidItem/shared/BidIncrementModal'
import useIsDesktop from '@utilities/hooks/useIsDesktop'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'
import InfoSlideOut from '@components/InfoSlideOut/InfoSlideOut'
import ViewPalletLotModal from '@components/ViewPalletLotModal/ViewPalletLotModal'

const Modals = () => {
  const { modal, itemState, auction, infoSlideOutOpen, setInfoSlideOutOpen } =
    useItemPage()
  const isDesktop = useIsDesktop()
  const { instance } = useContext<any>(AuthContext)
  const {
    state: {
      showBidModal,
      showBanModal,
      showBinMaoModal,
      showViewModal,
      showViewPalletLotModal,
      negativeZBid,
      negativeZBan,
      negativeZBinMao,
      negativeZView,
      modalAction,
      modalData,
      modalType,
      bins,
      offers,
      showViewBtn,
      incrementModalVisible,
    },
    handlers: { setBins, setOffers, toggleModal, setIncrementModalVisible },
    refs: { descriptionRef, titleRef, imagesRef },
  } = modal
  const {
    itemClosed,
    bidsEnabled,
    binEnabled,
    maoEnabled,
    currentBid,
    removed,
    palletLot,
  } = itemState

  return (
    <>
      <InfoSlideOut
        open={infoSlideOutOpen}
        setOpen={setInfoSlideOutOpen}
        auction={auction}
      />
      <BidIncrementModal
        itemId={String(itemState.id)}
        visible={incrementModalVisible}
        setVisible={setIncrementModalVisible}
        containerStyle={`h-72 w-96 max-w-full top-1/3 md:top-1/3 sm:-ml-0 -ml-8`}
        containerStyleObj={{
          top:
            descriptionRef?.current?.clientHeight +
              titleRef?.current?.clientHeight +
              (!isDesktop ? imagesRef?.current?.clientHeight + 250 : 100) ||
            null,
        }}
        innerContainerStyle="shadow-lg"
      />
      {!itemClosed &&
        !removed &&
        (currentBid === 0 || currentBid) &&
        bidsEnabled && (
          <>
            <BidModal
              showModal={showBidModal}
              negativeZ={negativeZBid}
              toggleModal={toggleModal}
              modalAction={modalAction}
              modalData={modalData}
            />
            <BanModal
              showModal={showBanModal}
              negativeZ={negativeZBan}
              toggleModal={toggleModal}
              modalData={modalData}
            />
          </>
        )}
      {(binEnabled || maoEnabled) && (
        <OfferModal
          showModal={showBinMaoModal}
          negativeZ={negativeZBinMao}
          auction={auction}
          item={itemState}
          type={modalType}
          instance={instance}
          bins={bins}
          setBins={setBins}
          offers={offers}
          setOffers={setOffers}
          toggleModal={toggleModal}
        />
      )}
      {showViewBtn && (
        <ViewModal
          showModal={showViewModal}
          negativeZ={negativeZView}
          item={itemState}
          toggleModal={toggleModal}
        />
      )}
      {palletLot && (
        <ViewPalletLotModal
          showModal={showViewPalletLotModal}
          negativeZ={negativeZView}
          item={itemState}
          toggleModal={toggleModal}
        />
      )}
    </>
  )
}

export default Modals
